import { render, staticRenderFns } from "./seek.vue?vue&type=template&id=3986f2a8&scoped=true&"
import script from "./seek.vue?vue&type=script&lang=js&"
export * from "./seek.vue?vue&type=script&lang=js&"
import style0 from "./seek.vue?vue&type=style&index=0&id=3986f2a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986f2a8",
  null
  
)

export default component.exports